import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchApprovePatient } from '../services/patient';

export function useApprovePatient() {
    const { id } = useParams<{ id: string }>();

    return useQuery({
        queryKey: ['patient', id, 'approve'],
        queryFn: () => fetchApprovePatient(id!),
        enabled: id !== undefined,
        staleTime: 0
    });
}
